import { useMemo } from 'react'

import { useAppBuilderContext } from '@/context/AppBuilderContext'

export type ColorScheme = 'dark' | 'light' | 'match-device'

export const getSystemThemeV2 = (e?: MediaQueryList | MediaQueryListEvent) => {
  if (!e) e = window.matchMedia('(prefers-color-scheme: dark)')
  const isDark = e.matches
  const systemTheme = isDark ? 'dark' : 'light'
  return systemTheme as 'light' | 'dark'
}

/**
 * React hook to resolve temp builder color scheme issue
 *
 * the `saved` value refers to users saved color scheme preference (`dark` | 'light` | 'match-device`), while
 * the `current` value refers tp the resolved color scheme (`dark` or `light`)
 */
export function useBuilderColorSchemeV2() {
  const { project } = useAppBuilderContext()
  const projectColorScheme = project?.scheme as ColorScheme

  const value = useMemo(
    () => ({
      saved: projectColorScheme,
      current: projectColorScheme === 'match-device' ? getSystemThemeV2() : projectColorScheme,
    }),
    [projectColorScheme]
  )

  return [value] as const
}
